export const getColorGenerator = (colors) =>
  (function* colorGenerator() {
    let i = 0;

    while (true) {
      yield colors[i % colors.length];
      i = i += 1;
    }
  })();
